import { render } from "./EditAutoCloseModal.vue?vue&type=template&id=5fc9e6fa&scoped=true"
import script from "./EditAutoCloseModal.vue?vue&type=script&lang=js"
export * from "./EditAutoCloseModal.vue?vue&type=script&lang=js"

import "./EditAutoCloseModal.vue?vue&type=style&index=0&id=5fc9e6fa&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc9e6fa"]])

export default __exports__